import React, { FunctionComponent } from 'react'
import { Text, useDate } from '@afterpaytouch/core'
import { getConsumerInitials } from '../../component/PaymentTypes/helper'
import { useCheckoutSizes } from '../../utils/responsive'
import { useAppRouter, useConsumerLendingStartDate, useConsumerName, useSelectedPaymentOption } from '../../state'
import { Trans } from '../../utils/convergence'
import styles from './style.module.css'
import { useMoney } from '../../component/Money/useMoney'

export const PlanOverview: FunctionComponent = () => {
  const { locale } = useAppRouter()
  const { sectionHeadingSize, smallTextSize } = useCheckoutSizes()
  const consumerName = useConsumerName()
  const selectedPaymentOption = useSelectedPaymentOption()
  const { formatMoney } = useMoney({
    locale,
    currency: selectedPaymentOption?.totalAmount.currency,
  })
  const { formatDate } = useDate({ locale, weekday: 'short' })
  const consumerLendingStartDate = useConsumerLendingStartDate()

  return (
    <div className={styles.planOverview}>
      <div className={styles.avatar}>
        <Text size='L' bold color='Gray80'>
          {getConsumerInitials(consumerName)}
        </Text>
      </div>
      <div className={styles.planOverviewText}>
        <Text size={sectionHeadingSize} bold>
          <Trans
            i18nKey='consumerLending:summary.profileCard:downPayment'
            values={{
              downPayment: formatMoney(selectedPaymentOption?.amountDueToday.amount),
            }}
          />
        </Text>
        <Text size={smallTextSize} color='Gray40'>
          <Trans
            i18nKey='consumerLending:summary.profileCard:paymentSchedules'
            values={{
              paymentsCount: selectedPaymentOption?.installmentsCount,
              startDate: formatDate(consumerLendingStartDate),
            }}
            context={selectedPaymentOption?.paymentInterval}
          />
        </Text>
      </div>
    </div>
  )
}
